import { useSelector } from 'react-redux'
import { CustomLink } from '../../../../common/CustomLink'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../../routers/constants'
import { selectTopPlayersItem } from './store/slice'

export const CompanyNameCell = ({ item, value, rowId }) => {
  const organizationId = useSelector(
    selectTopPlayersItem(rowId, 'organizationId'),
  )
  const allowRedirectLink = useSelector(
    selectTopPlayersItem(rowId, 'allowRedirectLink'),
  )

  return (
    <CustomLink
      target="_blank"
      to={
        COMPONENTS.companyAnalysis.components.summary.route +
        '?organizationId=' +
        organizationId
      }
      inActive={!allowRedirectLink}
    >
      <TextEllipsisStaticLine
        text={item.format(value)}
        isI18n={false}
        lineClamp={1}
        appendStyle={{
          color: allowRedirectLink && '#2C73E8',
        }}
      />
    </CustomLink>
  )
}
